import * as yup from 'yup';
import { patternNumero2Decimales } from '../../../utils/redexPatterns.js';
import formatMoneyNumber, { formatNumber } from '../../../utils/formatNumber.js';

// Define the custom method here
yup.addMethod(yup.number, 'campoObligatorio', function(errorMessage, valuesPesadas) {
  return this.test(`error-obligatorio`, errorMessage, function(value) {
    const { path, createError } = this;
    let isValid = true;
    /*
      path : pesadas[0].bultos[2].no_bultos
    */
    let pathArr = path.split('.bultos');
    let numeroPesada = Number(pathArr[0].substring(pathArr[0].indexOf('[') + 1, pathArr[0].lastIndexOf(']')));
    let id_cat_unidad_entrega = Number(pathArr[1].substring(pathArr[1].indexOf('[') + 1, pathArr[1].lastIndexOf(']')));

    if (Number(id_cat_unidad_entrega) !== 7) {
      if (typeof valuesPesadas[numeroPesada] !== 'undefined') {
        let id_cat_unidades_entregas = valuesPesadas[numeroPesada].id_cat_unidades_entregas;
        if (id_cat_unidades_entregas.includes(Number(id_cat_unidad_entrega))) {
          if (Number.isInteger(value) && Number(value) > 0) {
            isValid = true;
          } else {
            isValid = false;
          }
        }
      }
    }
    return isValid || createError({ path, message: errorMessage });
  });
});

export const getValidationSchema = (
  coopConfig,
  valuesPesadas,
  pendientePagoCredito,
  anticipoPago,
  montoPagar,
  MSJ_REQUERIDO = 'Información obligatoria'
) => {

  const validacionNumero2Decimales = yup
    .number()
    .transform(value => (isNaN(value) ? undefined : value))
    .test('is-number', 'Se espera un número', value => {
      return typeof value === 'number';
    })
    .min(0, 'Se espera que sea mayor o igual a 0')
    .test('is-decimal', 'Solo se permiten dos decimales', val => {
      return patternNumero2Decimales.test(val);
    });

  const validacionPorcentajes = () => {
    return yup
      .number()
      .transform((value, originalValue) => {
        if (originalValue === '' || originalValue === null || originalValue === undefined) {
          return null;
        }
        const number = Number(originalValue);
        return isNaN(number) ? undefined : number;
      })
      .test('is-number', 'El valor debe ser un número', value => {
        if (value === null) return true;
        return typeof value === 'number' && !isNaN(value);
      })
      .test('is-positive', 'Se espera un valor entero entre 0 y 100', value => {
        if (value === null || value === undefined) return true;
        return value >= 0;
      })
      .test('is-decimal', 'Solo se permiten dos decimales', value => {
        if (value === null || value === undefined) return true;
        return patternNumero2Decimales.test(value);
      })
      .test('is-positive', 'Se espera un valor entero entre 0 y 100', value => {
        if (value === null || value === undefined) return true;
        return value <= 100;
      })
      .nullable();
  };

  const bultosSchema = {
    no_bultos: yup
      .number()
      .integer('Debe introducir un valor entero')
      .transform(value => (isNaN(value) ? undefined : value))
      .campoObligatorio(MSJ_REQUERIDO, valuesPesadas),
  };

  const pesadaSchema = {
    id_acopio_pesadas: yup
      .number()
      .min(0)
      .nullable(),
    id_cat_unidades_entregas: yup
      .array()
      .min(1, 'Seleccione al menos una opción')
      .required('Seleccione al menos una opción'),
    peso_bruto: validacionNumero2Decimales.min(0.01, 'se espera que sea mayor a 0').required(MSJ_REQUERIDO),
    bultos: yup.array().of(yup.object().shape(bultosSchema)),
  };

  return yup.object().shape({
    id_acopio: yup
      .number()
      .min(0)
      .nullable(),
    id_acopio_pesada: yup
      .number()
      .min(0)
      .required(),
    id_acopio_muestreo: yup
      .number()
      .min(0)
      .required(),
    id_acopio_pago: yup
      .number()
      .min(0)
      .required(),
    id_cuenta: yup.number().min(1),
    uuid: yup.string(),
    fecha_ejecucion: yup
      .date()
      .nullable()
      .transform((curr, orig) => (orig === '' ? null : curr))
      .required(MSJ_REQUERIDO),
    fecha_cosecha: yup.date().nullable(),
    // .transform((curr, orig) => (orig === '' ? null : curr)),
    // .required(MSJ_REQUERIDO),
    pesadas: yup.array().of(yup.object().shape(pesadaSchema)),
    peso_tara: yup
      .number()
      .typeError('El campo es obligatorio. Si no tienen tara pueden poner 0.')
      .transform((value, originalValue) => {
        if (originalValue === '' || originalValue === null || originalValue === undefined) {
          return null;
        }
        const number = Number(originalValue);
        return isNaN(number) ? undefined : number;
      })
      .test('is-number', 'El valor debe ser un número', value => {
        if (value === null) return true;
        return typeof value === 'number' && !isNaN(value);
      })
      .test('is-positive', 'El monto debe ser igual o mayor a 0', value => {
        if (value === null || value === undefined) return true;
        return value >= 0;
      })
      .test('is-decimal', 'Solo se permiten dos decimales', value => {
        if (value === null || value === undefined) return true;
        return patternNumero2Decimales.test(value);
      })
      .nullable(false, MSJ_REQUERIDO),
    peso_descuento: yup
      .number()
      .transform((value, originalValue) => {
        if (originalValue === '' || originalValue === null || originalValue === undefined) {
          return null;
        }
        const number = Number(originalValue);
        return isNaN(number) ? undefined : number;
      })
      .test('is-number', 'El valor debe ser un número', value => {
        if (value === null) return true;
        return typeof value === 'number' && !isNaN(value);
      })
      .test('is-positive', 'El monto debe ser igual o mayor a 0', value => {
        if (value === null || value === undefined) return true;
        return value >= 0;
      })
      .test('is-decimal', 'Solo se permiten dos decimales', value => {
        if (value === null || value === undefined) return true;
        return patternNumero2Decimales.test(value);
      })
      .nullable(),
    peso_descuento_humedad: yup
      .number()
      .transform((value, originalValue) => {
        if (originalValue === '' || originalValue === null || originalValue === undefined) {
          return null;
        }
        const number = Number(originalValue);
        return isNaN(number) ? undefined : number;
      })
      .test('is-number', 'El valor debe ser un número', value => {
        if (value === null) return true;
        return typeof value === 'number' && !isNaN(value);
      })
      .test('is-positive', 'El monto debe ser igual o mayor a 0', value => {
        if (value === null || value === undefined) return true;
        return value >= 0;
      })
      .test('is-decimal', 'Solo se permiten dos decimales', value => {
        if (value === null || value === undefined) return true;
        return patternNumero2Decimales.test(value);
      })
      .nullable(),
    peso_descuento_perc: validacionPorcentajes(),
    peso_descuento_humedad_perc: validacionPorcentajes(),
    tipo_maduracion: yup.string().nullable(),
    rendimiento: validacionPorcentajes(),
    humedad: validacionPorcentajes(),
    mancha: validacionPorcentajes(),
    id_color: yup.string().nullable(),
    color_de_cafe: yup.string().nullable(),
    aroma: yup.string().nullable(),
    observaciones: yup.string().nullable(),
    id_cat_certificacion: yup
      .string()
      .test('len', 'Información requerida', val => val.length > 0 || !coopConfig.mostrarTipo())
      .nullable(),
    precio_por_kg: yup
      .number()
      .transform((value, originalValue) => {
        if (originalValue === '' || originalValue === null || originalValue === undefined) {
          return 0;
        }
        const number = Number(originalValue);
        return isNaN(number) ? undefined : number;
      })
      .test('is-number', 'El valor debe ser un número', value => {
        if (value === null) return true;
        return typeof value === 'number' && !isNaN(value);
      })
      .test('is-positive', 'El precio debe ser mayor a 0', value => {
        if (value === null || value === undefined) return true;
        return value >= 0;
      })
      .test('is-decimal', 'Solo se permiten dos decimales', value => {
        if (value === null || value === undefined) return true;
        return patternNumero2Decimales.test(value);
      })
      .nullable(),
    precio_por_kg_extra: yup
      .number()
      .transform((value, originalValue) => {
        if (originalValue === '' || originalValue === null || originalValue === undefined) {
          return 0;
        }
        const number = Number(originalValue);
        return isNaN(number) ? undefined : number;
      })
      .test('is-number', 'El valor debe ser un número', value => {
        if (value === null) return true;
        return typeof value === 'number' && !isNaN(value);
      })
      .test('is-positive', 'El precio debe ser mayor a 0', value => {
        if (value === null || value === undefined) return true;
        return value >= 0;
      })
      .test('is-decimal', 'Solo se permiten dos decimales', value => {
        if (value === null || value === undefined) return true;
        return patternNumero2Decimales.test(value);
      })
      .nullable(),
    recuperacion_credito: yup
      .number()
      .transform(value => (isNaN(value) ? undefined : value))
      .when([], {
        is: () => formatNumber(pendientePagoCredito + anticipoPago) > 0,
        then: yup
          .number()
          .min(0, 'Se espera un valor mayor o igual a 0')
          .max(
            formatNumber(pendientePagoCredito + anticipoPago),
            'Se espera un valor menor o igual a ' + formatMoneyNumber(pendientePagoCredito + anticipoPago)
          )
          .transform(value => (isNaN(value) ? undefined : value))
          .nullable(),
        otherwise: yup
          .number()
          .min(0, 'Se espera un valor mayor o igual a 0')
          .max(
            formatNumber(pendientePagoCredito + anticipoPago),
            'Se espera un valor menor o igual a ' + formatMoneyNumber(pendientePagoCredito + anticipoPago)
          )
          .transform(value => (isNaN(value) ? undefined : value))
          .nullable(),
      }),
    monto_pagado: yup
      .number()
      .transform((value, originalValue) => {
        if (originalValue === '' || originalValue === null || originalValue === undefined) {
          return null;
        }
        const number = Number(originalValue);
        return isNaN(number) ? undefined : number;
      })
      .test('is-number', 'El valor debe ser un número', value => {
        if (value === null) return true;
        return typeof value === 'number' && !isNaN(value);
      })
      .test('is-positive', 'El monto debe ser mayor a 0', value => {
        if (value === null || value === undefined) return true;
        return value >= 0;
      })
      .test('is-decimal', 'Solo se permiten dos decimales', value => {
        if (value === null || value === undefined) return true;
        return patternNumero2Decimales.test(value);
      })
      .max(formatNumber(montoPagar), 'El monto no debe ser mayor a ' + coopConfig.currency()?.symbol + ' ' + formatMoneyNumber(montoPagar))
      .nullable(),
    id_metodo_pago: yup.number().when('monto_pagado', {
      is: val => val > 0,
      then: yup
        .number()
        .transform(value => (isNaN(value) ? undefined : value))
        .required(MSJ_REQUERIDO),
      otherwise: yup
        .number()
        .transform(value => (isNaN(value) ? undefined : value))
        .nullable(),
    }),

    id_recoleccion_acopio: yup
      .number()
      .transform(value => (isNaN(value) ? undefined : value))
      .nullable(),
    creditos: yup
      .array()
      .min(0)
      .nullable(),
    firma_image: yup.string().nullable(),
    id_cat_costaleras_estatus: yup
      .number()
      .transform(value => (isNaN(value) ? undefined : value))
      .nullable(),
  });
};
